import { useState, useCallback } from "react"
import {
  remindInstallment,
  sendDemandLetter,
  updateReminderSettings,
} from "../api/collectionsApi"

function useMutation(fn) {
  const [isPending, setPending] = useState(false)
  const mutate = useCallback(
    async (...args) => {
      setPending(true)
      try {
        return await fn(...args)
      } catch (err) {
        throw err.response?.data?.errors || [err.message || "Something went wrong"]
      } finally {
        setPending(false)
      }
    },
    [fn]
  )
  return { mutate, isPending }
}

export const useRemindInstallment = () => useMutation(remindInstallment)
export const useSendDemandLetter = () => useMutation(sendDemandLetter)
export const useUpdateReminderSettings = () => useMutation(updateReminderSettings)
